import { cn } from "@/utils/utils";
import { User, Package, Download, Key } from "lucide-react";
import { ReactComponent as MusioLogo } from "@/assets/musio-logos/musio-logo-square.svg";
import { Link } from "wouter";

export function MainNav() {
  const pathname = window.location.toString();
  const baseClassName = "flex items-center h-full gap-1 transition-colors px-2 py-1 rounded hover:bg-musio-bg-light";

  return (
    <div className="mr-4 flex h-full">
      <a href="https://musio.com" className="mr-6 flex items-center space-x-2">
        <MusioLogo className="h-8 w-8" />
      </a>
      <nav className="flex items-center gap-4 font-normal font-metcon tracking-[-2px]">
        <Link
          to="~/account"
          className={cn(
            baseClassName,
            pathname.includes("account") ? "text-white" : "text-white/60"
          )}
        >
          <User className="h-4 w-4" />
          <span className="pl-2.5 pb-1 hidden md:block">ACCOUNT</span>
        </Link>
        <Link
          to="~/marketplace"
          className={cn(
            baseClassName,
            (pathname.includes("marketplace")) ? "text-white" : "text-white/60"
          )}
        >
          <Package className="h-4 w-4" />
          <span className="pl-2.5 pb-1 hidden md:block">MARKETPLACE</span>
        </Link>
        <Link
          to="~/account/download-musio"
          className={cn(
            baseClassName,
            "text-white/60 hidden md:inline-flex items-center gap-1"
          )}
        >
          <Download className="h-4 w-4" />
          <span className="pl-2.5 pb-1 hidden md:inline">DOWNLOAD</span>
        </Link>
        <Link
          to="~/account/licenses"
          className={cn(baseClassName, "text-white/60")}
        >
          <Key className="h-4 w-4 rotate-90" />
          <span className="pl-2.5 pb-1 hidden md:block">ADD LICENSE</span>
        </Link>
      </nav>
    </div>
  );
}
